import React from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { styled, Drawer as MuiDrawer, useMediaQuery } from '@mui/material';

import Icon from '../icons/Icon';
import { ICONS } from '../icons';
import { toggleSidebar } from '../redux/sidebar/sidebarReducer';
import HeaderColumn from '../header/components/header-column/HeaderColumn';
import MobileMenu from './components/mobile-menu/MobileMenu';
import AllProjectButton from '../header/components/projects/AllProjectButton';
import scss from './HeaderMobile.module.scss';
import BurgerMenuIcon from './components/burger-menu-icon/BurgerMenuIcon';
import ActionsWrapper from './components/actions-wrapper/ActionsWrapper';
import ProjectsHeader from '../header/components/projects/ProjectsHeader';
import SonarCommonHeader from '../header/components/sonar-common/SonarCommonHeader';
import CustomersHeader from '../header/components/customers/CustomersHeader';
import UserManagementHeader from '../header/components/user-management/UserManagementHeader';
import ScoutHeader from '../header/components/scout/ScoutHeader';
import GenieHeader from '../header/components/genie/GenieHeader';
import GenieGoHeader from '../header/components/genie-go/GenieGoHeader';
import Id8Header from '../header/components/id8/Id8Header';
import AiPlaygroundHeader from '../header/components/ai-playground/AiPlaygroundHeader';
import ResonanceHeader from '../header/components/resonance/ResonanceHeader';
import SonarDashboardHeader from '../header/components/sonar-dashboard/SonarDashboardHeader';
import SonarSettings from '../header/components/sonar-dashboard/SonarSettings';
import SonarDataTableSwitch from '../header/components/sonar-dashboard/SonarDataTableSwitch';
import ResonanceIvisButton from '../header/components/resonance/ResonanceIvisButton';
import MultipleRoute from '../components/multiple-route/MultipleRoute';
import Activ8Header from '../header/components/activ8/Activ8Header';

function HeaderMobile() {
  const isTablet = useMediaQuery('(max-width: 1024px)');

  const dispatch = useDispatch();

  const slimSidebar = useSelector((state) => state.sidebar.slim);

  const handleToggleMenu = () => {
    dispatch(toggleSidebar());
  };

  if (!isTablet) {
    return null;
  }

  return (
    <div className={scss.wrapper}>
      <header className={scss.header}>
        <Link to='/projects'>
          <Icon icon={ICONS.Logo} className={scss.logo} />
        </Link>

        <HeaderColumn>
          <Routes></Routes>
        </HeaderColumn>

        <HeaderColumn>
          <MultipleRoute paths={['/projects/create/*', '/projects/edit/*']} element={<AllProjectButton />} />
          <Routes>
            <Route
              path='/project/sonar/:id'
              element={
                <>
                  <SonarSettings />
                  <SonarDataTableSwitch />
                </>
              }
            />
            <Route path='/project/resonance/:id' element={<ResonanceIvisButton />} />
          </Routes>

          <BurgerMenuIcon />
        </HeaderColumn>
      </header>

      <Drawer open={!slimSidebar} hidden={slimSidebar} anchor='right' onClose={handleToggleMenu} variant='temporary'>
        <MobileMenu />
      </Drawer>

      <Routes>
        <Route
          path='/project/sonar/:id'
          element={
            <ActionsWrapper>
              <SonarDashboardHeader />
            </ActionsWrapper>
          }
        />
        <Route path='/project/sonar/collect-data/:id' element={<SonarCommonHeader />} />
        <Route path='/customers/*' element={<CustomersHeader />} />
        <Route path='/users/*' element={<UserManagementHeader />} />
        <Route
          path='/projects/*'
          element={
            <ActionsWrapper>
              <ProjectsHeader />
            </ActionsWrapper>
          }
        />
        <Route path='/project/scout/*' element={<ScoutHeader />} />
        <Route path='/project/genie/:id' element={<GenieHeader />} />
        <Route path='/project/genie-go/:id' element={<GenieGoHeader />} />
        <Route path='/project/id8/:id' element={<Id8Header />} />
        <Route path='/project/activ8/:id' element={<Activ8Header />} />
        <Route path='/project/scout/collect-data/*' element={<ScoutHeader />} />
        {/* <Route path='/settings/*' element={<SettingsHeader />} /> */}
        <Route path='/playground' element={<AiPlaygroundHeader />} />
        <Route path='/project/resonance/:id' element={<ResonanceHeader />} />
      </Routes>
    </div>
  );
}

export default HeaderMobile;

const Drawer = styled(MuiDrawer)({
  '& .MuiDrawer-paper': {
    background: 'var(--sidebar-bg)',
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px',
  },
  '& .MuiBackdrop-root': {
    opacity: '0 !important',
  },
});
